import { createContext, useContext, useEffect, useState } from 'react'

import { api } from '../api'

export type AdminType = {
  id?: number
  adminName?: string
  role?: string
}

const defaultValue: AdminType = {}

export const AdminContext = createContext<any>(defaultValue)

export const useAdmin = () => useContext(AdminContext)

export const AdminProvider = ({ children }) => {
  const [adminData, setAdminData] = useState(defaultValue)
  const [loading, setLoading] = useState(false)

  const isAdmin = () => {
    return adminData.role === 'ADMIN'
  }

  const fetchData = () => {
    setLoading(true)

    api
      .get('/admin')
      .then((response) => {
        setLoading(false)

        const { data, status } = response
        setAdminData({
          ...adminData,
          id: data.id,
          adminName: data.name,
          role: data.role,
        })
      })
      .catch((err) => {
        setLoading(false)
        setAdminData(defaultValue)
        console.error(err)
        window.location.href = '/login.html'
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <AdminContext.Provider value={{ ...adminData, isAdmin, isLoading: loading }}>
      {adminData.id && children}
    </AdminContext.Provider>
  )
}
